import { render, staticRenderFns } from "./checkUpIndividualStatusDetail.vue?vue&type=template&id=2c58b7c0"
import script from "./checkUpIndividualStatusDetail.vue?vue&type=script&lang=js"
export * from "./checkUpIndividualStatusDetail.vue?vue&type=script&lang=js"
import style0 from "./checkUpIndividualStatusDetail.vue?vue&type=style&index=0&id=2c58b7c0&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c58b7c0')) {
      api.createRecord('2c58b7c0', component.options)
    } else {
      api.reload('2c58b7c0', component.options)
    }
    module.hot.accept("./checkUpIndividualStatusDetail.vue?vue&type=template&id=2c58b7c0", function () {
      api.rerender('2c58b7c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/checkUpIndividualStatusDetail.vue"
export default component.exports